import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Chip,
  Alert,
  CircularProgress,
} from "@mui/material";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";

import { useApi } from "../utils/api";
import { ENDPOINTS } from "../config/endpoints";

const STORAGE_KEY_PREFIX = "bildirim_dialog_shown_for_kurum_";

const YeniDosyaTuruBildirim = () => {
  const http = useApi();
  const userData = JSON.parse(localStorage.getItem("user") || "null");
  const isKurum = userData?.type === "kurum";
  const kurumId = userData?.id;

  const [yeniTurler, setYeniTurler] = useState([]);
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!isKurum || !kurumId) return;

    // Aynı oturumda tekrar göstermemek için
    const shownKey = STORAGE_KEY_PREFIX + kurumId;
    if (sessionStorage.getItem(shownKey)) return;

    let cancelled = false;

    (async () => {
      try {
        // Kurum bilgilerini çek (son_bildirim_okuma için)
        const kurum = await http.get(`/kurumlar/${kurumId}`);
        const since = kurum?.son_bildirim_okuma;

        // since varsa filtre uygula, yoksa tüm türleri çek
        const params = { only_aktif: true };
        if (since) params.since = since;

        const turler = await http.get(ENDPOINTS.DOSYA_TURU.LIST, params);
        if (cancelled) return;

        if (Array.isArray(turler) && turler.length > 0) {
          setYeniTurler(turler);
          setOpen(true);
          sessionStorage.setItem(shownKey, "1");
        }
      } catch (e) {
        // Sessizce geç
      }
    })();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOk = async () => {
    setSaving(true);
    try {
      await http.put(`/kurumlar/${kurumId}/bildirim-okuma`);
      setOpen(false);
    } catch (e) {
      // hata olsa bile dialog'u kapat (user deneyimi)
      setOpen(false);
    } finally {
      setSaving(false);
    }
  };

  if (!isKurum) return null;

  return (
    <Dialog open={open} onClose={() => {}} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <NotificationsActiveIcon color="warning" />
        Yeni Dosya Türleri Eklendi
      </DialogTitle>
      <DialogContent dividers>
        <Alert severity="info" sx={{ mb: 2 }}>
          Sistemde son ziyaretinden bu yana <strong>{yeniTurler.length}</strong> yeni dosya türü
          eklendi. Lütfen kurumunuzdaki personellerin bu dosyalarını kontrol edip eksikse yükleyin.
        </Alert>

        <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
          Eklenen türler:
        </Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
          {yeniTurler.map((t) => (
            <Chip
              key={t.id}
              label={t.ad}
              color={t.zorunlu ? "warning" : "default"}
              variant={t.zorunlu ? "filled" : "outlined"}
            />
          ))}
        </Box>

        <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: "block" }}>
          <strong>Sarı dolu</strong> rozetler zorunlu türleri, gri kontur opsiyonel türleri gösterir.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleOk} disabled={saving}>
          {saving ? <CircularProgress size={18} /> : "Anladım, kontrol edeceğim"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default YeniDosyaTuruBildirim;
